/**
 * vm.$watchOnce
 * 监听一次某值的变化，触发callback
 * 主要使用场景：处理某逻辑时，保证前置需要的数据已经获取，如异步获取的prop值，获取到了才能进行下一步请求
 * *target: 类似$watch的第一个参数，可以是String或Function，监听变化的目标
 * *callback: 类似$watch的第二个参数，target变化时的回调函数
 * options: 类似$watch的第三该参数，包含deep,immediate,checkValue三个配置项
 * options.deep: 同$watch的deep配置，默认为false
 * options.immediate: 为true时，在调用后立即触发一次，默认为true
 * options.checkValue: 一个函数，接收target对应值，返回值为true时表示该值符合需求，符合时才会触发callback
 *
 * 使用例：（vue组件文件中）
 * beforeMount() {
        this.$watchOnce('myAsyncProp',()=>{
            this.getMyDataByAsyncProp()
        });
    }
 */

export default {
    install(Vue) {
        Vue.prototype.$watchOnce = function(target, callback, {deep = false, immediate = true, checkValue = val => val} = {}) {
            let curVal;
            if (typeof target === 'string') {
                curVal = _.get(this, target);
            } else if (typeof target === 'function') {
                curVal = target.call(this);
            }
            if (immediate && checkValue(curVal)) {
                callback.call(this, curVal);
            } else {
                const unwatch = this.$watch(
                    target,
                    function(newVal, oldVal) {
                        if (checkValue(newVal)) {
                            unwatch();
                            callback.call(this, newVal, oldVal);
                        }
                    },
                    {deep}
                );
            }
        };
    }
};



// WEBPACK FOOTER //
// ./src/assets/plugin/watchOnce.js